/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */
import type { QueryFunction, QueryKey, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { FrontendConfiguration, ProblemDetails } from '../../model';
import type { ErrorType } from '../../utils/UseCustomInstance';
import { useCustomInstance } from '../../utils/UseCustomInstance';

export const useGetFrontendConfigurationHook = () => {
    const getFrontendConfiguration = useCustomInstance<FrontendConfiguration>();

    return (signal?: AbortSignal) => {
        return getFrontendConfiguration({ url: `/FrontendConfiguration`, method: 'get', signal });
    };
};

export const getGetFrontendConfigurationQueryKey = () => [`/FrontendConfiguration`] as const;

export const useGetFrontendConfigurationQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetFrontendConfigurationHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFrontendConfigurationHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFrontendConfigurationHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetFrontendConfigurationQueryKey();

    const getFrontendConfiguration = useGetFrontendConfigurationHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetFrontendConfigurationHook>>>> = ({ signal }) =>
        getFrontendConfiguration(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetFrontendConfigurationQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetFrontendConfigurationHook>>>>;
export type GetFrontendConfigurationQueryError = ErrorType<ProblemDetails>;

export const useGetFrontendConfiguration = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetFrontendConfigurationHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFrontendConfigurationHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetFrontendConfigurationQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};
